import { Spacer, TextTitle } from '@pypestream/design-system';
import { TranslationComponent } from '@pypestream/translations';
import { useNavigate } from 'react-router';

import {
  StudioPageProps,
  useProStudioRoutes,
} from '../hooks/use-pro-studio-routes';
import { WithLoadingState } from '../router';
import {
  BrandingOptionsFormValues,
  ChannelSettingsForm,
  SizingOptionsFormValues,
} from '../components';
import { useProStudioViewerRole } from '../hooks';
import { ErrorPage } from './error-page';

type ChannelCreatePageProps = StudioPageProps;

const customStyling = {
  buttonColor: '#454545',
  textColor: '#FFFFFF',
  brandMomentUrl: '',
};

const brandingFormDefaultValues: BrandingOptionsFormValues = {
  launcherName: 'Engage with us',
  widgetStyleColor: '#007BFF',
  widgetStyleTextColor: '#FFFFFF',
  agentBubbleColor: '#DEE8F5',
  agentBubbleTextColor: '#000000',
  userBubbleColor: '#113260',
  userBubbleTextColor: '#FFFFFF',
  name: 'Web Conversational Interface',
  logo: '',
  bannerUrl: '',
  customPypeCss: '',
  ...customStyling,
};

const sizingFormDefaultValues: SizingOptionsFormValues = {
  widgetWidth: 500,
  widgetHeight: 800,
  shouldLockRatio: false,
};

const ChannelCreatePage: React.FC<ChannelCreatePageProps> = () => {
  const isViewer = useProStudioViewerRole();
  const navigate = useNavigate();
  const channelsPath = useProStudioRoutes().channels.path;

  if (isViewer) {
    return (
      <ErrorPage
        label="You are not authorized to create a channel"
        body="Contact an admin to request access."
        buttonText="Go to channels"
        buttonOnClick={() => navigate(channelsPath)}
      />
    );
  }
  return (
    <>
      <TextTitle test-id="ps-create-channel-title" size="small">
        <TranslationComponent i18nKey="pro-studio/channel-details:title.create">
          Create Channel
        </TranslationComponent>
      </TextTitle>
      <Spacer size="large" />
      <ChannelSettingsForm
        type="create"
        values={{
          detailsFormValues: {
            name: '',
            env: 'sandbox',
            pypeId: '',
            streamId: '',
          },
          brandingFormValues: brandingFormDefaultValues,
          sizingFormValues: sizingFormDefaultValues,
        }}
      />
    </>
  );
};

export const ChannelCreate = WithLoadingState(ChannelCreatePage);
